import {useRef} from "react";
import {useSetState} from "ahooks";
import {message} from "antd";
import {SActionBtn, SDrawerOrModal, SFuncModalFormRef, SLowcodeList, SMessage, STableActions} from "shj-components";

import {getConfig} from "./config.tsx";
import AddOrEditConfigure from "./addOrEdit";
import {convertListToTree} from "@/utils/common.ts";

const TableList = (props) => {
  const {current, apiUrlObj} = props
  const listRef = useRef()
  const editRef = useRef<SFuncModalFormRef>({onFinish: undefined});
  const [state, setState] = useSetState<any>(
      {
        exportLoading: false,
        visible: false,
        record: {},
        treeList: [],
        loading: false
      })

  const fetchList = ({query}) => {
    return new Promise((resolve, reject) => {
      apiUrlObj.getPage({data: query}).then(res => {
        const tree = convertListToTree(res,{pid: 'parentId'})
        resolve({records: tree})
        setState({treeList: [{name: '顶级分类', id: '0'},...tree]})
      }).catch(reject)
    })
  }

  const onAddOrEdit = (record = {}) => {
    setState({visible: true, record: {...record}})
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  };

  const onCancel = () => {
    setState({visible: false, record: {}, loading: false})
  }

  const onChangeStatus = (record: Record<string, any>) => {
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${!record.status ? '启用' : '停用'}该数据`,
      onOk: () => {
        return apiUrlObj.updateById({...record, status: !record.status}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd: () => onAddOrEdit()},
    customRender: {
      jsonRender(v: any) {
        const {shops: list} = v && JSON.parse(v)
        return list?.map(item => item.name)?.join(', ')
      },
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
          <SActionBtn onClick={() => onChangeStatus(record)} danger={record.status}>{record.status ? '停用' : '启用'}</SActionBtn>
        </STableActions>
      },
    }
  }

  return (
      <div>
        <SLowcodeList ref={listRef} searchMode={'group'} fieldControl={false}
                      config={getConfig(current.key)} {...extensions}/>
        <SDrawerOrModal mode={'modal'}
                        width={500}
                        onCancel={onCancel}
                        onOk={onSubmit}
                        open={state.visible}
                        loading={state.loading}
                        title={(state.record.id ? '编辑' : '新增') + current.label}
        >
          <AddOrEditConfigure
              fn={listRef.current?.reload}
              onClose={onCancel}
              apiObj={apiUrlObj}
              editRef={editRef}
              current={current}
              setLoading={(loading: boolean) => setState({loading})}
              treeList={state.treeList}
              record={state.record}/>
        </SDrawerOrModal>
      </div>
  );
};

export default TableList;
